var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHolidayByLake = function SvgHolidayByLake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.937H22M6.51582 14.937L11.9998 8.54258L17.4838 14.937M2.82263 14.937L6.32868 10.7198L8.10904 13.0793M21.1772 14.937L17.6712 10.7198L15.8908 13.0793M18.9533 18.1302H12.7639M13.0935 20.8647H10.7496M9.40454 18.9115H6.78719M7.20146 4.4243C7.20146 5.21094 6.56376 5.84859 5.77716 5.84859C4.99052 5.84859 4.35283 5.21094 4.35283 4.4243C4.35283 3.63766 4.99052 3 5.77716 3C6.56376 3 7.20146 3.63766 7.20146 4.4243Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHolidayByLake;